import { toast } from "react-toastify";
import { postMethod, setAuthorizationToken } from "../../api-service/api-service";
import { setLoading, setUser } from "./authSlice";
import Cookies from "js-cookie";

export const loginAction = (data) => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        const response = await postMethod("/auth/login", data);
        if (response.success === true) {
            dispatch(setUser(response?.user));
            setAuthorizationToken(response?.token);
            const token = response?.token;
            Cookies.set("jwt", token, { expires: 7 });
            toast.success("Login Successfull");
        } else {
            toast.error(response?.message || "Login Failed");
        }
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        console.log("Error: ", error)
        toast.error("Unable to login at the moment")
        return { success: false, message: error }
    }
}